export default "__VITE_ASSET__BE_MBp_j__"